export default __webpack_public_path__ + "images/lock-icon-1d764c.svg";